export default __webpack_public_path__ + "static/media/inactiveHamburger.da6728d6.svg";